(() => {
  'use strict';
  const mobile = window.matchMedia('(max-width: 749px)');
  const start = () => {
    const root = document.querySelector('[id^="ProductInfo-"]');
    if (!root || root.dataset.lvcPdpReview) return;
    root.dataset.lvcPdpReview = 'true';
    const picker = root.querySelector('variant-selects');
    const buy = root.querySelector('#product-container');
    const helper = root.querySelector('.lvc-mobile-buy-helper');
    const change = root.querySelector('.lvc-size-change-banner');
    const buyAnchor = document.createComment('lvc-buy-position');
    const helperAnchor = document.createComment('lvc-helper-position');
    const changeAnchor = document.createComment('lvc-change-position');
    if (buy) buy.before(buyAnchor);
    if (helper) helper.before(helperAnchor);
    if (change) change.before(changeAnchor);
    let queued = false;
    const sync = () => {
      queued = false;
      const label = root.querySelector('[data-lvc-size-option] .variants-label');
      // Keep last-pair / two-pairs urgency next to the selected size, not below purchase.
      const stock = root.querySelector('[id^="LvcLowStock-"]');
      const sizeText = label && label.querySelector('span');
      if (sizeText && stock && !sizeText.contains(stock)) sizeText.append(stock);
      const guide = root.querySelector('.pify-overlay-button');
      if (label && guide && !label.querySelector('.lvc-size-guide-trigger')) {
        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'lvc-size-guide-trigger';
        trigger.innerHTML = guide.innerHTML;
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.addEventListener('click', () => {
          const original = root.querySelector('.pify-overlay-button');
          if (original) original.click();
        });
        label.append(trigger);
      }
      // Product purchase controls must immediately follow size options on desktop and mobile.
      // Keep mobile helper/size banner placement as it was before.
      if (picker && buy) {
        if (picker.nextElementSibling !== buy) picker.after(buy);
      } else if (buy && buyAnchor.nextSibling !== buy) {
        buyAnchor.after(buy);
      }
      // Show the existing EXPRESS block after the add-to-cart form,
      // but before the store-trust message. Reuse the same live countdown.
      const express = root.querySelector('#express-delivery-bar');
      const trust = buy && buy.querySelector('.lvc-cro-store-trust');
      if (buy && express && trust && (express.parentElement !== buy || express.nextElementSibling !== trust)) {
        trust.before(express);
      } else if (buy && express && !trust && express.parentElement !== buy) {
        buy.append(express);
      }
      if (mobile.matches) {
        if (helper && buy && buy.nextElementSibling !== helper) buy.after(helper);
        if (helper && change && helper.nextElementSibling !== change) helper.after(change);
      } else {
        if (helper && helperAnchor.nextSibling !== helper) helperAnchor.after(helper);
        if (change && changeAnchor.nextSibling !== change) changeAnchor.after(change);
      }
    };
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(sync);
    };
    new MutationObserver(records => {
      if (records.some(r => Array.from(r.addedNodes).some(n => n.nodeType === 1))) schedule();
    }).observe(root, { childList: true, subtree: true });
    mobile.addEventListener('change', schedule);
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
